import { ByLinePattern, ByLinePatternShift, CustomField, PageInfo } from 'types/graphql';
import { ApolloClient } from '@apollo/client';

export const PATTERN_LIBRARY_PAGE_SIZE = 20;

export interface PatternLibraryState {
  data: ByLinePattern[];
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  hasInitialized: boolean;

  // Pagination state
  pageInfo: Pick<PageInfo, 'endCursor' | 'hasNextPage'> | null;
  isLoadingMore: boolean;

  // Pattern detail (shifts loaded on demand)
  activePatternDetailLoading: boolean;
  patternDetailLoaded: Record<string, boolean>; // relayId -> boolean

  // Custom fields data
  customFieldsData: Record<string, CustomField[]>; // patternRelayId -> CustomField[]
  customFieldsLoading: Record<string, boolean>; // patternRelayId -> boolean
  customFieldsInitialized: Record<string, boolean>; // patternRelayId -> boolean

  // Actions
  setLoading: (loading: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setError: (error: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchData: (apolloClient: ApolloClient<any>) => Promise<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadMore: (apolloClient: ApolloClient<any>, searchQuery?: string) => Promise<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refetch: (apolloClient: ApolloClient<any>, searchQuery?: string) => Promise<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  search: (apolloClient: ApolloClient<any>, searchQuery: string) => Promise<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchPatternDetail: (apolloClient: ApolloClient<any>, patternRelayId: string) => Promise<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refetchPatternShiftHours: (apolloClient: ApolloClient<any>, patternId: string) => Promise<void>;

  fetchAvailableCustomFields: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    apolloClient: ApolloClient<any>,
    patternRelayId: string,
  ) => Promise<void>;
  addPatternShift: (patternId: string, patternShift: ByLinePatternShift) => void;
  updatePatternShift: (
    patternId: string,
    originalShift: ByLinePatternShift,
    updatedShift: ByLinePatternShift,
  ) => void;
  deletePatternShift: (patternId: string, patternShiftId: string) => void;
  addPattern: (pattern: ByLinePattern) => void;
  updatePattern: (pattern: ByLinePattern) => void;
  deletePattern: (patternDisplayId: number) => void;
  reset: () => void;
}
